import { Icon } from "@iconify/react";
import { useRef, useState } from "react";
import editFill from "@iconify/icons-eva/edit-fill";
import copyFill from "@iconify/icons-eva/copy-fill";
import { Link as RouterLink } from "react-router-dom";
import trash2Outline from "@iconify/icons-eva/trash-2-outline";
import moreVerticalFill from "@iconify/icons-eva/more-vertical-fill";
import mapMarkerInfo from "@iconify/icons-uil/map-marker-info";
// material
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

// ----------------------------------------------------------------------

export default function LocationMoreMenu({
  moreInfoMode = false,
  onEdit,
  onDelete,
  onCopyTo,
  onMoreInfo,
  hasEdit = true,
  hasCopyTo = false,
}) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: "100%" },
        }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {!moreInfoMode && hasCopyTo && (
          <MenuItem
            onClick={() => {
              setIsOpen(false);
              onCopyTo();
            }}
            sx={{ color: "text.secondary" }}
          >
            <ListItemIcon>
              <Icon icon={copyFill} width={24} height={24} />
            </ListItemIcon>
            <ListItemText
              primary="Copy To"
              primaryTypographyProps={{ variant: "body2" }}
            />
          </MenuItem>
        )}

        {!moreInfoMode && hasEdit && (
          <MenuItem
            onClick={() => {
              setIsOpen(false);
              onEdit();
            }}
            sx={{ color: "text.secondary" }}
          >
            <ListItemIcon>
              <Icon icon={editFill} width={24} height={24} />
            </ListItemIcon>
            <ListItemText
              primary="Edit"
              primaryTypographyProps={{ variant: "body2" }}
            />
          </MenuItem>
        )}
        {!moreInfoMode && (
          <MenuItem
            onClick={() => {
              setIsOpen(false);
              onDelete();
            }}
            sx={{ color: "text.secondary" }}
          >
            <ListItemIcon>
              <Icon icon={trash2Outline} width={24} height={24} />
            </ListItemIcon>
            <ListItemText
              primary="Delete"
              primaryTypographyProps={{ variant: "body2" }}
            />
          </MenuItem>
        )}

        {moreInfoMode && (
          <MenuItem
            onClick={() => {
              setIsOpen(false);
              onMoreInfo();
            }}
            sx={{ color: "text.secondary" }}
          >
            <ListItemIcon>
              <Icon icon={mapMarkerInfo} width={24} height={24} />
            </ListItemIcon>
            <ListItemText
              primary="More Info"
              primaryTypographyProps={{ variant: "body2" }}
            />
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
